export default __webpack_public_path__ + "static/media/paper2.8f9b7b92.JPG";